export var Product;
(function (Product) {
    Product["CreditCard"] = "credit_card";
    Product["Loan"] = "loan";
    Product["Mortgage"] = "mortgage";
    Product["Deposits"] = "deposits";
    Product["LifeInsurance"] = "life_insurance";
    Product["Other"] = "other";
})(Product || (Product = {}));
//# sourceMappingURL=productsKeys.js.map